export const withoutEmptyHeaders = (headers) =>
	Object.entries(headers).reduce((result, [name, value]) => {
		if (value !== undefined && value !== null && value !== '') result[name] = value
		return result
	}, {})
